import axios from 'axios';

const useImageDownloader = () => {
  const downloadImage = async (imageUrl) => {
    try {
      if (!imageUrl) throw new Error('Invalid image URL');

      const urlParts = imageUrl.split('/');
      const folderName = urlParts[urlParts.length - 2];
      const fileNameParts = urlParts[urlParts.length - 1].split('.');
      const baseFileName = fileNameParts[0];
      const fileExtension = fileNameParts[1];

      const response = await axios.get(imageUrl, { responseType: 'blob' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute(
        'download',
        `${folderName}_${baseFileName}.${fileExtension}`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  return { downloadImage };
};

export default useImageDownloader;
